module.exports = __webpack_public_path__ + "components/rewards/bird-eyewear/static/icon-ef32919247bfab88f292036f84014c74.png";